import React from "react";
import { useIntl } from "react-intl";
import classNames from "classnames";

import { ReactComponent as SadFaceIcon } from "static/icons/sad-face.svg";
import styles from "./ComponentError.module.scss";

interface Props {
    classes?: {
        root?: string;
    };
    errorMessage?: string;
}

const ComponentError = ({ classes, errorMessage }: Props) => {
    const intl = useIntl();
    return (
        <div className={classNames(styles["error"], classes?.root)}>
            <SadFaceIcon className={styles["error__icon"]} />
            <div className={styles["error__content"]}>
                <h3 className={styles["error__title"]}>
                    {intl.formatMessage({
                        id: "common_error.title",
                    })}
                </h3>
                <p className={styles["error__description"]}>
                    {errorMessage ?? intl.formatMessage({
                        id: "common_error.description",
                    })}
                </p>
            </div>
        </div>
    );
};

export default ComponentError;
